<template>
  <div class="modal active">
    <div class="modal-overlay"></div>
    <div class="modal-container">
      <div class="modal-header">
        <button
          class="btn btn-clear float-right"
          @click="$emit('emitHide')"></button>
        <div class="modal-title">
          Latest QReserve Updates
        </div>
      </div>
      <div class="modal-body">
        <div v-if="err">{{ err }}</div>
        <div v-for="d in dates">
          <h4>{{ dateFormat(d) }}</h4>
            <div v-for="note in notesForDate(d)" class="note">
              <span
                v-for="tag in majorTags(note.tags)"
                class="label-tag"
                :style="tagStyle(tag)">{{ tagMod(tag) }}</span>
              <!---
              <span
                v-for="tag in minorTags(note.tags)"
                class="label-tag label-minor-tag"
                :style="tagStyle(tag)">{{ tagMod(tag) }}</span>
              -->
              <h6>{{ note.title }}</h6>
              <p
                v-html="note.description"
                style="clear: both;"></p>
            </div>
        </div>
        <div class="loading" v-if="loading"></div>
        <button
          class="btn btn-link"
          v-if="hasMore && !loading"
          @click="loadMore"
          >Load more...</button>
      </div>
      <div class="modal-footer">
        <button
          class="btn btn-link"
          @click="$emit('emitHide')">
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue';
import _ from 'lodash';
import moment from 'moment';

import { Get, urls } from 'assets/js/api';
import { UserSettings } from 'assets/js/usersettings';
import { TAGS } from 'assets/js/releasenotes';

export default {
  name: 'release-notes-modal',

  components: {
  },

  computed: {
    notesByDate() {
      const byDate = {};
      _.forEach(this.notes, (n) => {
        if (!byDate[n.date]) {
          byDate[n.date] = [];
        }
        byDate[n.date].push(n);
      });
      return byDate;
    },

    dates() {
      return _.map(
        _.uniqBy(this.notes, (n) => n.date),
        (n) => n.date,
      );
    },
  },

  created() {
  },

  data() {
    return {
      loading: false,
      hasMore: true,
      err: null,
      notes: [],
      offset: 0,
      limit: 10,
      tags: TAGS,
      userSettings: UserSettings(this.$store),
    };
  },

  emits: [
    'emitHide',
  ],

  methods: {
    majorTags(tags) {
      return _.filter(tags,
        (t) => ['Feature', 'Bug Fix',
          'Improvement', 'Optimization'].indexOf(t) !== -1);
    },

    minorTags(tags) {
      return _.filter(tags,
        (t) => ['Feature', 'Bug Fix',
          'Improvement', 'Optimization'].indexOf(t) === -1);
    },

    tagMod(tag) {
      if (tag === 'Feature') {
        return 'New Feature';
      }

      return tag;
    },

    dateFormat(d) {
      return moment(d).format('LL');
    },

    async fetchReleaseNotes() {
      this.err = null;
      this.loading = true;
      try {
        let url = urls.RELEASE_NOTES;
        url += `?offset=${this.offset}&limit=${this.limit}`;
        const resp = await Get(url);
        this.hasMore = resp.data.length === this.limit;
        this.notes = this.notes.concat(resp.data);
      } catch (err) {
        this.err = err;
      }
      this.loading = false;
    },

    loadMore() {
      this.offset += this.limit;
      this.fetchReleaseNotes();
    },

    notesForDate(date) {
      if (this.notesByDate[date]) {
        return this.notesByDate[date];
      }
      return [];
    },

    tagStyle(tag) {
      const tagDef = _.find(this.tags, (t) => t[0] === tag);
      if (!tagDef) return { backgroundColor: '#333', color: 'white' };
      return { backgroundColor: tagDef[1], color: tagDef[2] };
    },
  },

  mounted() {
    this.fetchReleaseNotes();
    window.umami?.track('Release Notes');
  },

  props: {
  },

  watch: {
    err: {
      handler: function handle(err) {
        Sentry.captureException(err);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~assets/css/colors";
  @import "~assets/css/labels";

  .label-tag {
    margin-right: 0.2em;
    margin-bottom: 0.2em;
    font-size: 1.0rem;
    border-radius: 0.3em;
    padding: 0 0.5em;
    font-weight: bold;
    display: inline-block;
    width: 10em;
    text-align: center;
  }

  h4 {
    padding: 0.3em 0;
    margin-bottom: 0;
    font-size: 1.6rem;
    border-bottom: 2px solid;
  }

  .note {
    padding: 0.5em 0 0 0;
    border-bottom: 1px solid #DDD;
    p {
      font-size: 0.9em;
    }
    h6 {
      margin-bottom: 0;
      font-size: 1.0em;
    }
  }

  .dark-mode {
    .note {
      border-color: #444;
    }
    h4 {
      border-color: #444;
    }
  }

  .note:last-child {
    border-bottom: none;
    margin-bottom: 1em;
  }

  .tag-column {
    width: 10em;
    padding-right: 1em;
    text-align: center;
  }
</style>
